<template>
  <tr>
    <template v-for="(value, index) in arrWeek">
      <template v-if="value != ''">
        <td :class="{ 'active bg-color-skin-dark-10': checkSelectedDay(value), 'bg-hover-color-skin-light-10' : pcDisp }" v-on:click="setSelectDate({ date: value, day: index })">
          <div class="clearfix">
            <div class="set-number-date">{{ value }}</div>
            <template v-if="calendar.total > 0">
              <div :class="{ 'fa fa-circle reserved-date color-skin' : checkReserveDate(value) }"></div>
            </template>
          </div>
        </td>
      </template>
      <template v-else>
        <td><div></div></td>
      </template>
    </template>
  </tr>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'hres82e-week-row',
  props: [ 'arrWeek', 'setSelectDate', 'checkCurrentDay', 'checkSelectedDay', 'calendar', 'selectedMonth', 'selectedYear', 'selectingYear', 'selectingMonth' ],
  methods: {
    checkReserveDate (date) {
      let selectedDate = _.padStart(date, 2, '0') + '/' + _.padStart(this.selectingMonth, 2, '0') + '/' + _.padStart(this.selectingYear, 2, '0')
      let calendarRowsFiltered = this.calendar.rows.filter(function (calendarRow) {
        return calendarRow.dtereserv === selectedDate
      })
      return calendarRowsFiltered.length > 0
    }
  }
}
</script>


// WEBPACK FOOTER //
// weekRow.vue?35cf63d8